import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TacsCodeKreis } from '@entity/tacs-code-kreis';
import { ContextService } from '@service/context.service';
import { VariableService } from '@service/variable.service';

export const OrganizationCategoryResolve: ResolveFn<TacsCodeKreis[]> = () => {
  return inject(VariableService).getOrganizationCategories(inject(ContextService).getMandantIdInstant());
};
